export * as Freeze from './freeze';
export { isReadonlyArray } from './freeze';
export { Assert } from '@cotera/utilities';
export { TODO } from './todo';

export const ISO8601_REGEX =
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
